import { PrimeReactStylesFunctionType } from '../types';
import { classNames } from 'primereact/utils';

export const InputSwitchTailwindThemes = {
  inputswitch: {
    root: ({ props }: PrimeReactStylesFunctionType) => ({
      className: classNames('inline-block relative shrink-0', 'w-9 h-5.5', {
        'opacity-60 select-none pointer-events-none cursor-default': props.disabled,
      }),
    }),
    input: {
      className: classNames(
        'peer absolute appearance-none top-0 left-0 size-full p-0 m-0',
        'opacity-0 z-10 outline-none cursor-pointer rounded-2xl',
      ),
    },
    slider: ({ props }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'absolute cursor-pointer top-0 left-0 right-0 bottom-0 border border-transparent',
        'transition-colors duration-200 rounded-2xl',
        'outline-transparent peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-fletchers-green-500',
        'before:absolute before:content-"" before:top-1/2 before:bg-white before:w-3.5 before:h-3.5',
        'before:left-0.75 before:-mt-1.75 before:rounded-full before:duration-200',
        {
          'bg-fletchers-gray-100 peer-hover:bg-fletchers-gray-150': !props.checked,
          'before:transform before:translate-x-3.5 bg-fletchers-green-500 peer-hover:bg-fletchers-green-900':
            props.checked,
        },
      ),
    }),
  },
};
